import { Checkbox, RadioButton, Switch, Textarea } from "@centricsoftware/design-system";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { EXPRESSION_RUNTIME_ENUM_CONTINUOUS, EXPRESSION_RUNTIME_ENUM_ONETIME, useAttributeDefinitionStore } from "./AttributeDefinitionStore";

const AttributeDefinitionSectionExpression: FunctionComponent = observer(() => {
	const { 
		attrUOMEnabled,
		attrExpression,
		attrExpressionEnabled,
		attrExpressionError,
		attrExpressionEvaluateOnClient,
		expressionState,
		locale,
		onChangeExpression,
		onChangeExpressionEnabled,
		onChangeExpressionEvaluateOnClient,
		onChangeExpressionState,
	} = useAttributeDefinitionStore();

	const {
		helperTextEvaluateOnClientRes,
		helperTextExpressionRuntimeContinuous,
		helperTextExpressionRuntimeOneTime,
		labelEnableExpressionRes,
		labelExpressionRes,
		labelExpressionContinuous,
		labelExpressionEvaluateOnClientRes,
		labelExpressionOneTime,
		labelExpressionRuntimeRes,
	} = locale;
	return (
		<>
			<Textarea
				error={!!attrExpressionError}
				errorMessage={attrExpressionError}
				labelRes={labelExpressionRes}
				onChange={onChangeExpression}
				required={attrExpressionEnabled}
				value={attrExpression}
			/>
			{!attrUOMEnabled && (
				<Checkbox
					ariaLabelRes={labelExpressionEvaluateOnClientRes}
					checked={attrExpressionEvaluateOnClient}
					helperTextRes={helperTextEvaluateOnClientRes}
					labelRes={labelExpressionEvaluateOnClientRes}
					onChange={onChangeExpressionEvaluateOnClient}
				/>
			)}
			<Switch
				checked={attrExpressionEnabled}
				labelRes={labelEnableExpressionRes}
				onChange={onChangeExpressionEnabled}
			/>
			{attrExpressionEnabled && (
				<RadioButton
					ariaLabelRes={labelExpressionRuntimeRes}
					labelRes={labelExpressionRuntimeRes}
					onChange={onChangeExpressionState}
					options={[
						{
							helperText: helperTextExpressionRuntimeContinuous,
							id: EXPRESSION_RUNTIME_ENUM_CONTINUOUS,
							label: labelExpressionContinuous,
							value: EXPRESSION_RUNTIME_ENUM_CONTINUOUS,
						},
						{
							helperText: helperTextExpressionRuntimeOneTime,
							id: EXPRESSION_RUNTIME_ENUM_ONETIME,
							label: labelExpressionOneTime,
							value: EXPRESSION_RUNTIME_ENUM_ONETIME,
						},
					]}
					value={expressionState}
				/>	
			)}
		</>
	);
});

export default AttributeDefinitionSectionExpression;